import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Your main stylesheet
import App from './App'; // Import the corrected App component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);